import { render, staticRenderFns } from "./component-upload.vue?vue&type=template&id=0b54255e"
import script from "./component-upload.vue?vue&type=script&lang=js"
export * from "./component-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports